// Web entry point — replaces index.js for the webpack build
// Does NOT register Firebase background handlers (native-only)
import './web/polyfills'; // MUST be first — sets Platform.constants before other modules eval
import './web/fonts.css'; // @font-face for @ant-design icon fonts (web-only)
import { handleOAuthCallback } from './web/auth/handleOAuthCallback';
import { AppRegistry } from 'react-native';
import App from './App';
import { name as appName } from './app.json';

// Exchange OAuth code for tokens if redirected back from Kinde
handleOAuthCallback()
  .then(() => {
    AppRegistry.registerComponent(appName, () => App);
    AppRegistry.runApplication(appName, {
      rootTag: document.getElementById('app-root'),
    });
  })
  .catch(err => {
    console.error('[web] startup failed:', err);
  });
